import { format } from 'date-fns';
import styled from 'styled-components';

import { DischargeCalendarCounts, WeekViewResponse } from 'services/api/dischargeCalendar';

import DayColumn from './DayColumn';

interface WeekViewGridProps {
  daysOfWeek: Date[];
  weekData?: WeekViewResponse;
  counts?: DischargeCalendarCounts;
  isLoading: boolean;
}

export default function WeekViewGrid({ daysOfWeek, weekData, counts, isLoading }: WeekViewGridProps) {
  return (
    <GridContainer>
      {daysOfWeek.map((date) => {
        const dateKey = format(date, 'yyyyMMdd');
        return (
          <DayColumn
            key={date.toISOString()}
            date={date}
            dayData={weekData?.[dateKey]}
            counts={counts?.[dateKey]}
            isLoading={isLoading}
          />
        );
      })}
    </GridContainer>
  );
}

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  flex: 1;
  min-height: 0;
  border: 1px solid ${({ theme }) => theme.colors.black15};
  border-radius: 8px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.white};
`;
